import gql from 'graphql-tag';

export const DELETE_ACCOUNTING_REPORT = gql`
  mutation DeleteAccountingReport($where: AccountingReportWhereUniqueInput!) {
    deleteReport(where: $where) {
      id
    }
  }
`;
